import PinCodeView from "./PinCodeView";

function Carrier() {
    return (
        <PinCodeView />
    )
}

export default Carrier;